import { WithTranslation } from 'next-i18next'
import React from 'react'
import { withTranslation } from '../../../i18n'
import { isMobile as isMobileJS } from '../../utils'

type TProps = {
	name: string
	logo: string
	url: string
	hasNewJobs: boolean
	companyLength: number
} & WithTranslation

const widthBlockBasedLength = {
	3: 33.33,
	4: 25,
	5: 20,
	6: 16.666666667
}

const CompanyBlockComponent = (props: TProps) => {
	const { t, name, hasNewJobs, logo, url, companyLength } = props

	const widthBlock = widthBlockBasedLength[companyLength] || 380
	const companyListUpto3: boolean = companyLength <= 3 ? true : false

	const areaLabel =
		t('Latest ') +
		`${name} ` +
		t('employment/hiring with high salary & attractive benefits')

	const isMobile = isMobileJS() ? true : false
	const tNewJobText = t('New jobs')
	return (
		<div
			className={`companyBlock  ${
				companyListUpto3 ? 'padding-16 company-box-3' : ''
			}`}
			style={{ flexBasis: isMobile ? '35%' : `33.33%` }}
		>
			<a href={url} target='_blank'>
				<div
					className='companyBlock__box view_job_item top_company'
					role='img'
					aria-label={areaLabel}
				>
					<img src={logo} alt='' />					
					<div className="companyBlock__content">
						<div className='companyBlock__name is-uppercase'>
							{name}
						</div>
						{hasNewJobs && (
							<span className="companyBlock__tag">{tNewJobText}</span>
						)}
					</div>					
				</div>
			</a>
		</div>
	)
}

const CompanyBlock = withTranslation('home')(CompanyBlockComponent)
export default CompanyBlock
